import SectionLabel from "@/components/base/SectionLabel";
import { capabilities } from "@/mocks/site";

export default function Capabilities() {
  return (
    <section id="fertigung" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <div className="mb-10 flex flex-col justify-between gap-6 border-b border-foreground-200 pb-8 md:mb-12 lg:flex-row lg:items-end">
          <div>
            <SectionLabel className="mb-5">Fertigung</SectionLabel>
            <h2 className="max-w-xl font-heading text-[28px] font-extrabold leading-[1.08] tracking-tightest text-foreground-950 sm:text-[34px] md:text-[42px]">
              Maschinenpark &amp; Verfahren.
            </h2>
          </div>
          <p className="max-w-md text-[14px] leading-relaxed text-foreground-600 md:text-[15px]">
            Konventionelle und CNC-gesteuerte Maschinen, dazu Arbeiten wie Rund- und Flachschleifen,
            Senkerodieren sowie Lichtbogen- und Schutzgasschweißen — alles im eigenen Haus, um in
            den Fertigungsprozessen flexibel zu bleiben.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-px bg-foreground-200 sm:grid-cols-2 lg:grid-cols-4">
          {capabilities.map((item, index) => (
            <div
              key={item.title}
              className="group bg-background-50 p-5 transition-colors duration-300 hover:bg-background-100 md:p-6"
            >
              <span className="font-label text-[10px] tracking-[0.18em] text-foreground-400">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-3 flex items-center gap-2 font-heading text-[15px] font-bold text-foreground-950">
                <span className="h-[2px] w-4 bg-primary-500 transition-all duration-300 group-hover:w-7" />
                {item.title}
              </h3>
              <p className="mt-2 text-[12.5px] leading-relaxed text-foreground-600">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}